import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import ReactAudioPlayer from 'react-audio-player';
import { useLoadContext } from "src/contexts/LoadContext";
import config from "src/config";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogAudioPlayer({ open, setOpen, handleEnded, value }) {
    const { user } = useLoadContext();

    const handleClose = () => {
        setOpen(false);
    }

    const getMediaUrl = (msg) => {
        if (!msg || !user) return "";
        return `${config.API_URL}mensagem/media/${msg._id}?token=${user.token}&userid=${user.id}&setor=${user.setor}`;
    };

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <div style={{ background: 'transparent' }}>
                {
                    value &&
                    <ReactAudioPlayer
                        onEnded={handleEnded}
                        autoPlay
                        title="audio.ogg"
                        src={getMediaUrl(value)}
                        controls
                    />
                }
            </div>
        </Dialog>
    );
}
